// src/components/TeamSection.tsx
import { motion } from 'framer-motion';

interface TeamMemberProps {
  name: string;
  position: string;
  bio: string;
  image: string;
  index: number;
  size: 'large' | 'small';
}

const TeamMember = ({ name, position, bio, image, index, size }: TeamMemberProps) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: index * 0.1 }}
    className="flex flex-col bg-white rounded-lg overflow-hidden shadow-md border border-stone-200 hover:shadow-[0_0_15px_rgba(240,90,40,0.3)] hover:border-secondary transition-all duration-300 transform-none"
  >
    <div className={`${size === 'large' ? 'h-64' : 'h-56'} overflow-hidden`}>
      <img src={image} alt={name} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <h3 className={`${size === 'large' ? 'text-xl' : 'text-lg'} font-semibold mb-1`}>{name}</h3>
      <p className="text-secondary font-medium mb-3">{position}</p>
      <p className="text-stone-600">{bio}</p>
    </div>
  </motion.div>
);

interface TeamSectionProps {
  teamMembers: {
    name: string;
    position: string;
    bio: string;
    image: string;
  }[];
}

const TeamSection = ({ teamMembers }: TeamSectionProps) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        {teamMembers.slice(0, 2).map((member, index) => (
          <TeamMember
            key={index}
            name={member.name}
            position={member.position}
            bio={member.bio}
            image={member.image}
            index={index}
            size="large"
          />
        ))}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {teamMembers.slice(2, 5).map((member, index) => (
          <TeamMember
            key={index}
            name={member.name}
            position={member.position}
            bio={member.bio}
            image={member.image}
            index={index + 2}
            size="small"
          />
        ))}
      </div>
    </>
  );
};

export default TeamSection;